























import _ from 'lodash';
import {Component, Vue } from 'vue-property-decorator';
import { DxScrollView } from 'devextreme-vue';
import InputControlHeader from '@/views/input-control/components/header.vue';
import ControlGrid from '@/views/input-control/components/control-table.vue';

import InputContolService from '@/services/input_control_service'
import AuthService from "@/services/auth_service";

@Component({
  name: 'InputControl',
  components: {
    DxScrollView,
    InputControlHeader,
    ControlGrid
  }
})


export default class extends Vue {


  public controlData: any = {};
  public isLoaded: boolean = false;

  async created() {
  }

  async mounted() {

  }

  get gridHeight() {
      return '100%';
  }

  async getLoad(params: any) {
    this.isLoaded = false;
    const resp = await InputContolService.getData(params.cut, params.year);
    if(resp) {
      this.controlData = resp;
      this.isLoaded = true;
    }
  }


  destroyed() {

  }

  empty() {
      //
  }



}
